<gp-modal #editOrgModal [closable]="true" size="sm">
  <div class="gp-modal-title" style="max-width: 90%">
    <h4 class="text-ellipsis">{{ editedOrg?.opts?.title }}</h4>
  </div>
  <div class="gp-modal-body">
    <form novalidate *ngIf="editedOrg">
      <div class="form-group col-md-12">
        <label>{{ 'ORGANIZATION.name' | translate }} <span class="required">*</span></label>
        <div class="input-group">
          <span class="input-group-addon pointer"
                (click)="toggleGenerateName()"
                [ngClass]="{
                  'disabled': !allowGenerateName(),
                  'pointer': allowGenerateName()
                }">
              <input type="checkbox"
                     style="pointer-events:none;"
                     name="mustGenerateName"
                     [disabled]="!allowGenerateName()"
                     [(ngModel)]="editedOrg.mustGenerateName">
              &nbsp;<small>Auto</small>
          </span>
          <input type="text"
                 name="name"
                 class="form-control"
                 test-id="org-edit-modal-name"
                 [ngClass]="{'gp-input-value-hidden': editedOrg.mustGenerateName}"
                 [(ngModel)]="editedOrg.name"
                 [required]="!editedOrg.mustGenerateName"
                 [disabled]="editedOrg.mustGenerateName"/>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label>{{ 'ORGANIZATION.Identification' | translate }}</label>
        <input class="form-control"
               type="text"
               name="otherid"
               (ngModelChange)="onChangeOfIdentification($event)"
               test-id="org-edit-modal-other-id"
               [(ngModel)]="editedOrg.otherId">
        <ul class="error-list" *ngIf="isOrgOtherIdTaken">
          <li>{{ 'FORMS.VALIDATORS.otherIdTaken' | translate }}</li>
        </ul>
      </div>
      <ng-container *ngIf="!editedOrg.opts.isCopy">
        <div class="form-group col-md-6">
          <label>{{ 'ORGANIZATION.allowed_regulations' | translate }} <span class="required">*</span></label>
          <gp-tree-multi-select
            test-id="org-edit-modal-allowed-regulations"
            [class.gp-error]="isAllowedRegulationInvalid()"
            [config]="treeConfig"
            [items]="regulationTree | sort: 'text'"
            (selectedChange)="onAllowedRegulationSelected($event)"
            (hide)="getConfidentialityFields()">
          </gp-tree-multi-select>
        </div>
        <div class="form-group col-md-6">
          <label>{{ 'ORGANIZATION.def_regulation' | translate }} <span class="required">*</span></label>
          <ng-select class="form-control"
                     test-id="org-edit-modal-default-regulation"
                     name="cliReg"
                     [class.gp-error]="isDefaultRegulationInvalid()"
                     [textField]="'nickName'"
                     [idField]="'cliRegId'"
                     [items]="editedOrg.opts.regulations | sort: 'nickName'"
                     [(ngModel)]="editedOrg.cliReg">
          </ng-select>
        </div>
        <div class="form-group col-md-12" *ngIf="isConfigurator() && isPayrollSetTree()">
          <label>{{ 'ORGANIZATION.pay_serie_id' | translate }}</label>
          <ng-select
            class="form-control"
            test-id="org-edit-modal-pay-serie-id"
            name="pay-serie-id"
            [textField]="'transId'"
            [idField]="'id'"
            [items]="paySeries | sort: 'transId'"
            [(ngModel)]="editedOrg.paySerieID">
          </ng-select>
        </div>
        <div class="col-xs-12 form-group checkbox">
          <input type="checkbox"
                 test-id="org-edit-modal-user-selectable"
                 id="user-selectable"
                 name="user-selectable"
                 [(ngModel)]="editedOrg.userSelectable">&nbsp;
          <label for="user-selectable">{{ 'ORGANIZATION.selectable' | translate }}</label>
        </div>
        <div *ngIf="userManagement !== null"
             class="col-xs-12 form-group checkbox">
          <input type="checkbox"
                 test-id="org-edit-modal-user-management"
                 id="user-management"
                 name="user-management"
                 [(ngModel)]="userManagement">&nbsp;
          <label for="user-management">{{ 'ORGANIZATION.user_management' | translate }}</label>
        </div>
      </ng-container>
      <div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ 'FORMS.begin_date' | translate }}</label>
            <datepicker-input name="begindate"
                              test-id="org-edit-modal-begin-date"
                              [hasEternity]="true"
                              (ngModelChange)="onChangeDates()"
                              [(ngModel)]="editedOrg.begindate"
                              (keyup)="onChangeDates()"
                              [dateRangeCorrection]="true">
            </datepicker-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ 'FORMS.end_date' | translate }}</label>
            <datepicker-input name="enddate"
                              test-id="org-edit-modal-end-date"
                              [(ngModel)]="editedOrg.enddate"
                              (ngModelChange)="onChangeDates()"
                              [hasEternity]="true"
                              (keyup)="onChangeDates()"
                              [dateRangeCorrection]="true">
            </datepicker-input>
          </div>
          <ul class="error-list begin-before-end" *ngIf="!isBeginBeforeEnd">
            <li>{{ 'FORMS.VALIDATORS.end_date_earlier_start_date' | translate }}</li>
          </ul>
        </div>
      </div>

      <div *ngIf="!editedOrg.opts.isCopy">
        <div class="col-md-12 org-edit-modal-title">
          <h3>{{ 'ORGANIZATION.parent' | translate }}</h3>
        </div>

        <div class="col-md-12 form-group">
          <label>{{ 'ORGANIZATION.name' | translate }} <span class="required">*</span></label>
          <gp-tree-select
            class="form-control"
            test-id="'org-edit-modal-parent'"
            [isSorted]="true"
            [tree]="parentsTree"
            [formControl]="selectOrgEditFormControl"
            [readOnly]="this.editedOrg?.opts?.isNew && !fromScratch"
            [lazyValue]="editedOrg.parentLazyValue"
            (elementSelected)="onElementSelected($event)">
          </gp-tree-select>
        </div>
        <div class="col-md-6 form-group">
          <label>{{ 'FORMS.parent_begin_date' | translate }}</label>
          <datepicker-input name="parentBeginDate2"
                            test-id="org-edit-modal-parent-begin-date"
                            [hasEternity]="true"
                            [disabled]="true"
                            [readOnly]="true"
                            [(ngModel)]="parentBeginDate"
                            [dateRangeCorrection]="true">
          </datepicker-input>
        </div>

        <div class="col-md-6 form-group">
          <label>{{ 'FORMS.parent_end_date' | translate }}</label>
          <datepicker-input name="parentEndDate2"
                            test-id="org-edit-modal-parent-end-date"
                            [hasEternity]="true"
                            [(ngModel)]="parentEndDate"
                            [disabled]="true"
                            [readOnly]="true"
                            [dateRangeCorrection]="true">
          </datepicker-input>
        </div>

        <div class="col-md-6 form-group" *ngIf="editedOrg?.tree !== 'Positions'">
          <label>{{ 'FORMS.relation_begin_date' | translate }}</label>
          <datepicker-input name="parentBeginDate"
                            test-id="org-edit-modal-parent-begin-date"
                            [hasEternity]="true"
                            (ngModelChange)="onChangeParentBeginDate($event)"
                            [(ngModel)]="editedOrg.parentBeginDate"
                            (keyup)="onChangeParentBeginDate(extractValue($event.target))"
                            [dateRangeCorrection]="true">
          </datepicker-input>
          <ul class="error-list begin-before-end" *ngIf="!isParentRelationBeginDateInsideRange">
            <li *ngIf="!isParentRelationBeginDateInsideRange">{{ 'FORMS.VALIDATORS.relation_begin_date_wrong' | translate }}</li>
          </ul>
        </div>

        <div class="col-md-6 form-group" *ngIf="editedOrg?.tree !== 'Positions'">
          <label>{{ 'FORMS.relation_end_date' | translate }}</label>
          <datepicker-input name="parentEndDate"
                            test-id="org-edit-modal-parent-end-date"
                            [hasEternity]="true"
                            (ngModelChange)="onChangeParentEndDate($event)"
                            [(ngModel)]="editedOrg.parentEndDate"
                            (keyup)="onChangeParentEndDate(extractValue($event.target))"
                            [dateRangeCorrection]="true">
          </datepicker-input>
          <ul class="error-list begin-before-end" *ngIf="!isParentBeginBeforeEnd  || !isParentRelationEndDateInsideRange">
            <li *ngIf="!isParentBeginBeforeEnd">{{ 'FORMS.VALIDATORS.end_date_earlier_start_date' | translate }}</li>
            <li *ngIf="!isParentRelationEndDateInsideRange">{{ 'FORMS.VALIDATORS.relation_end_date_wrong' | translate }}</li>
          </ul>
        </div>
      </div>

      <ng-container *ngIf="!editedOrg.opts.isCopy">

        <div *ngIf="loadingConfidFields" class="padding">
          <i class="fa fa-light fa-spinner fa-spin"></i>
        </div>

        <div #fieldRowsContainer></div>

        <ul class="error-list" *ngIf="isAllowedtoCreate === false">
          <li>{{ 'ORGANIZATION.disallowed_by_right' | translate }}</li>
        </ul>

      </ng-container>

      <div class="clearfix"></div>
    </form>
  </div>
  <div class="gp-modal-footer">
    <button class="btn btn-dark p-x-md"
            [disabled]="!isFormValid() || saving"
            (click)="confirmSaveIfNecessary(editOrgModal)">
      {{ 'FORMS.save' | translate }}
    </button>
    <button type="button"
            class="btn btn-secondary p-x-md"
            (click)="editedOrg = null; cancel(editOrgModal);">
      {{ 'FORMS.cancel' | translate }}
    </button>
  </div>
</gp-modal>
